import BaseServiceV2 from "./BaseServiceV2";
import ApiUrl from './ApiUrl';

class DashboardService extends BaseServiceV2 {

    constructor() {
        super(ApiUrl.SGKDomain + ApiUrl.controller.SGKDashboard);
    }


    async getBildirimYapilmamisIsKazasi({ date }) {
        const { resultObject } = await this.easyGet(ApiUrl.widgets.bildirimyapilmamisiskazasi, {
            date
        });
        return resultObject || 0;
    }

    async getGirisCikisKontrolhatasi({ date }) {
        const { resultObject } = await this.easyGet(ApiUrl.widgets.GirisCikisKontrolhatasi, {
            date
        });
        return resultObject || 0;
    }

    async getEnSonBorcSorguTarihi() {
        const { resultObject } = await this.easyGet(ApiUrl.widgets.ensonborcsorgutarihi);
        return resultObject?.calismaGunu;
    }

    async getEBorcToplami({ calismaGunu }) {
        const { resultObject } = await this.easyGet(ApiUrl.widgets.eborctoplami, { calismaGunu });
        return resultObject || 0;
    }

    async getBorcuOlanSirketSayisi({ calismaGunu }) {
        const { resultObject } = await this.easyGet(ApiUrl.widgets.borcuolansirketsayisi, { calismaGunu });
        return resultObject || 0;
    }

    async getBorcuOlanIsYeriSayisi({ calismaGunu }) {
        const { resultObject } = await this.easyGet(ApiUrl.widgets.borcuolanisyerisayisi, { calismaGunu });
        return resultObject || 0;
    }

    async getEBorcuYokturKayitlari() {
        const { resultObject } = await this.easyGet(ApiUrl.widgets.getEBorcuYokturKayitlari);
        return resultObject || 0;
    }

    async getHataAlanTescilIslemleri({ startDate, endDate }) {
        const { resultObject } = await this.easyGet(ApiUrl.widgets.hataalantescilislemleri, { startDate, endDate });
        return resultObject || 0;
    }

    async getTesvikKazanciniz({ periodId }) {
        const { resultObject } = await this.easyGet(ApiUrl.widgets.Tesvikkazanciniz, { periodId });
        return resultObject || 0;
    }

    async getEViziteOnayBekleyenler({ startDate, endDate }) {
        const { resultObject } = await this.easyGet(ApiUrl.widgets.eviziteonaybekleyenler, {
            startDate, endDate
        });
        return resultObject || 0;
    }

    async getPersonelSayisi({ periodId }) {
        const { resultObject } = await this.easyGet(ApiUrl.widgets.personelsayisi, { periodId });
        return resultObject || 0;
    }

    async viziteMahsup({ periodId }) {
        const { resultObject } = await this.easyGet(ApiUrl.widgets.viziteMahsup, { periodId });
        return resultObject || 0;
    }

}

const dashboardServicev2 = new DashboardService();

export default dashboardServicev2;
